import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetDistancesByVoucherParams, GetDistancesByVoucherResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getDistancesByVoucher = createAsyncThunk<
  GetDistancesByVoucherResponse,
  GetDistancesByVoucherParams
>(
  `vouchers/getDistancesByVoucher`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getDistancesByVoucher({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting distances by voucher",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting distances by voucher", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);